export const PLAY_POSITION_MEDIA_VIDEO = '|A|PositionalMediaActions.PLAY_VIDEO'

export const playPositionalMediaVideo = (autoPlay = false) => ({
    type: PLAY_POSITION_MEDIA_VIDEO,
    autoPlay,
})
